//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { pinOrderStateOption } from '../static';
import * as pintuanApi from '@/api/pintuanApi';
import throttle from '@/utils/throttle';
import transformState from '@/utils/transformState.js';
import OrderDetail from './pintuanOrderDetail.vue';
export default {
  components: {
    OrderDetail: OrderDetail
  },
  data: function data() {
    return {
      pinOrderStateOption: pinOrderStateOption,
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.handlerGetListData(this.listPram);
  },
  methods: {
    throttle: throttle,
    transformState: transformState,
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      pintuanApi.getPinOrderList(pram).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    // 查看订单详情
    openOrderDetail: function openOrderDetail(orderNo) {
      this.$refs['OrderDetailRef'].openDetail(orderNo);
    },
    previewQrImg: function previewQrImg(id) {
      var _this2 = this;
      pintuanApi.getPinQrcode({
        id: id
      }).then(function (img) {
        if (!img) return;
        //预览图片
        _this2.$previewImg({
          imageList: [img]
        });
      });
    },
    endPintuanOrder: function endPintuanOrder(row, type) {
      var _this3 = this;
      pintuanApi.changePinOrderInfo({
        id: row.id
      }).then(function (res) {
        var _ref = res || {},
          countPeople = _ref.countPeople,
          now = _ref.now;
        var timeStr = _this3._transportShowTime(now, row.endTime);
        var TYPE_MAP = {
          'end': {
            tips: "\u8FD8\u6709".concat(timeStr, "\u622A\u56E2\uFF0C\u73B0\u5DF2\u8DDF\u56E2").concat(countPeople, "\u4EBA\uFF0C\u786E\u5B9A\u73B0\u5728\u5B8C\u6210\u5417\uFF1F"),
            methodName: 'endOrders',
            params: {
              id: row.id,
              status: 2
            }
          },
          'cancel': {
            tips: "\u8FD8\u6709".concat(timeStr, "\u622A\u56E2\uFF0C\u73B0\u5DF2\u8DDF\u56E2").concat(countPeople, "\u4EBA\uFF0C\u786E\u5B9A\u73B0\u5728\u53D6\u6D88\u5417\uFF1F"),
            methodName: 'cancelOrders',
            params: {
              id: row.id,
              status: 4
            }
          }
        };
        var typeInfo = TYPE_MAP[type];
        _this3.$confirm(typeInfo['tips'], '提示', {
          type: 'warning'
        }).then(function (result) {
          pintuanApi.changePinOrderState(typeInfo.params).then(function (data) {
            _this3.$message.success('操作成功');
            _this3.handlerGetListData(_this3.listPram);
          });
        });
      });
    },
    _transportShowTime: function _transportShowTime(currentTime, endTime) {
      var outTimeStr = '';

      // 1. 解析日期字符串为 Date 对象
      var startDate = new Date(currentTime);
      var endDate = new Date(endTime);

      // 2. 计算两个日期之间的毫秒差异
      var diffMs = endDate - startDate;
      if (diffMs < 0) return '';

      // 3. 将毫秒差异转换为天、小时和分钟
      var diffTotalSeconds = Math.floor(diffMs / 1000);
      var diffDays = Math.floor(diffTotalSeconds / (24 * 3600));
      var diffHours = Math.floor(diffTotalSeconds % (24 * 3600) / 3600);
      var diffMinutes = Math.floor(diffTotalSeconds % 3600 / 60);

      // 4. 格式化结果字符串
      outTimeStr = "".concat(diffDays, "\u5929").concat(diffHours, "\u5C0F\u65F6").concat(diffMinutes, "\u5206");
      return outTimeStr;
    }
  }
};